module.exports = __webpack_public_path__ + "static/media/TheYearMyLifeWentDowntheToilet.ad1b79f7.jpg";